import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-waiting-for-players',
    imports: [CommonModule],
    templateUrl: './waiting-for-players.component.html',
    styleUrl: './waiting-for-players.component.scss'
})
export class WaitingForPlayersComponent {}
